import React from 'react';
import { DisplayConfiguration } from '@carvana/showroom-tooltip/Base/Content';
import {
  CancelPaymentLink,
  LinkWrapper,
  ScheduledPaymentsLabel,
  ScheduledPaymentsNote,
  ScheduledPaymentsRow,
  ScheduledPaymentsRowItem,
  TurnOffAutoPayLink,
} from '../ScheduledPayments.styles';
import InfoToolTip from '../../../../future-packages/info-tooltip';
import AutopayHelpDetails from '../autopay-help-details';
import { formatDate, DateMasks } from '../../../../../utils/dateUtils';
import { formatCurrency } from '../../../../../utils/CurrencyUtils';
import { useDualEventTracking } from '../../../../../utils/useDualEventTracking';

const Payment = (props: {
  isRecurring: boolean;
  paymentSchedule: any;
  onCancelPayment: any;
  onTurnOffAutopay: any;
  turnOffAutopayUrl: any;
}) => {
  const {
    isRecurring,
    paymentSchedule,
    onCancelPayment,
    onTurnOffAutopay,
    turnOffAutopayUrl,
  } = props;

  const { trackEvent } = useDualEventTracking();

  const tooltipDisplay: Partial<DisplayConfiguration> = {
    width: 300,
    height: 160,
    arrowOffsetX: 21,
    contentOffsetX: -10,
  };

  const cancelPayment = () => {
    trackEvent('scheduled_payments_cancel_button_tap');
    onCancelPayment();
  };

  return isRecurring ? (
    <ScheduledPaymentsRow>
      <ScheduledPaymentsRowItem>
        <ScheduledPaymentsLabel>
          {formatCurrency(paymentSchedule.withdrawAmount)}
        </ScheduledPaymentsLabel>
        <ScheduledPaymentsNote>One-Time Payment</ScheduledPaymentsNote>
      </ScheduledPaymentsRowItem>

      <ScheduledPaymentsRowItem>
        <ScheduledPaymentsLabel>
          {formatDate(paymentSchedule.paymentDate, DateMasks.MonthDayYear)}
        </ScheduledPaymentsLabel>
        <LinkWrapper>
          Scheduled &nbsp;|&nbsp;&nbsp;
          <TurnOffAutoPayLink
            className=".disable-link"
            to={turnOffAutopayUrl}
            onClick={onTurnOffAutopay}
          >
            Manage
          </TurnOffAutoPayLink>
          <InfoToolTip
            display={tooltipDisplay}
            trackEventContent="turn_off_auto_pay_tooltip_tap"
            content={() => <AutopayHelpDetails />}
          />
        </LinkWrapper>
      </ScheduledPaymentsRowItem>
    </ScheduledPaymentsRow>
  ) : (
    <ScheduledPaymentsRow className="paymentsRow">
      <ScheduledPaymentsRowItem>
        <ScheduledPaymentsLabel>
          {formatCurrency(paymentSchedule.withdrawAmount)}
        </ScheduledPaymentsLabel>
        <ScheduledPaymentsNote>One-Time Payment</ScheduledPaymentsNote>
      </ScheduledPaymentsRowItem>
      <ScheduledPaymentsRowItem>
        <ScheduledPaymentsLabel>
          {formatDate(paymentSchedule.paymentDate, DateMasks.MonthDayYear)}
        </ScheduledPaymentsLabel>
        {
          !paymentSchedule.isCancellable && <LinkWrapper>Scheduled</LinkWrapper> // not
        }
        {paymentSchedule.isCancellable && (
          <LinkWrapper>
            Scheduled &nbsp;|&nbsp;&nbsp;
            <CancelPaymentLink onClick={cancelPayment}>
              Cancel
            </CancelPaymentLink>
          </LinkWrapper>
        )}
      </ScheduledPaymentsRowItem>
    </ScheduledPaymentsRow>
  );
};
export default Payment;
